module.exports = __webpack_public_path__ + "img/icon-question-rating-group-radio_button.65a6c721.svg";